export default "<template>\n  <div>\n    <FdCalendar :firstDayOfWeek=\"1\" />\n  </div>\n</template>"